import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.117 14c-.993 0-1.49-1.174-.788-1.861l2.883-2.82a1.133 1.133 0 0 1 1.576 0l2.883 2.82c.703.687.205 1.861-.788 1.861z"
    }, null, -1)
  ])))
}
export default { render: render }